import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TGetAccrualPreviewsRequestSchema,
  TGetAccrualPreviewsResponseSchema,
} from "./getAccrualPreviews.schema";

export const getAccrualPreviews = (axios: IAxiosInstance) => {
  return async ({ checkIDs, companyID }: TGetAccrualPreviewsRequestSchema) => {
    const { data } = await axios.with502Retry.post<
      ZealApiResponse<TGetAccrualPreviewsResponseSchema>
    >(`/api/accrual-policies/previews`, {
      checkIDs,
      companyID,
    });

    if (data.success) {
      return data.data;
    }

    throw new Error("Something went wrong");
  };
};
